__turbopack_context__.v({
  "container": "Header-module__PJSaBa__container",
  "toggleBtn": "Header-module__PJSaBa__toggleBtn",
});
